module.exports = __webpack_public_path__ + "static/Rust-b81061f4b26cec196cc5f8063317db11.svg";